import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'

import RaisedButton from 'material-ui/RaisedButton'
import { MentionsInput, Mention } from 'react-mentions'

import AttachButton from '../Attachments/AttachButton'
import AttachmentsList from '../Attachments/AttachmentsList'

import commentActions from 'actions/commentActions'

import { doc, currentUser } from 'selectors/common'
import { managersData, propertiesData, tenantsData, repairmenData, agentsData, ownersData } from 'selectors/mentions'
import { attachmentsByObjectID } from 'selectors/attachments'

import { linkedText } from 'utils/commentsText'
import inputStyles from './inputStyles'

let select = (state, props) => ({
	...state
  , commentBuffer: state.commentBuffer
  , userID: currentUser(state)
  , object: doc(state, props.objectID)
  , attachments: attachmentsByObjectID(state)
  , managers: managersData(state)
  , properties: propertiesData(state)
  , tenants: tenantsData(state)
  , repairmen: repairmenData(state)
  , agents: agentsData(state)
  , owners: ownersData(state)
})

export class CommentForm extends Component {
	render(){
		let { props } = this
		let mode = props.commentBuffer.mode
		return(
			<div
				className="form-holder"
				style={{
					backgroundColor: "#F5F5F5"
				  , marginBottom: "15px"
				}}
			>
				<div
					style={{
						padding: "0px"
					}}
				>
					<form
						key={`${this.props.objectID}-mainForm`}
						onSubmit={(evt) =>{
							evt.preventDefault()
							props.COMMENT_SAVE({
								_id: props.commentBuffer.commentID
							  , contents: props.commentBuffer.contents
							  , objectID: props.objectID
							  , userID: props.userID
							  , type: 'comment'
							})
							return false
							}
						}
						style={{
							marginTop: "0px"
						  , width: "100%"
						  , display: "inline-block"
						  , position: "relative"
						}}
					>
						<MentionsInput
							value={ (props.commentBuffer && props.commentBuffer.contents)? props.commentBuffer.contents : "" }
							onChange={ (evt) => props.COMMENT_CHANGE(evt.target.value) }
							style={inputStyles}
							markup="@[__display__](__type__:__id__)"
						>
						</MentionsInput>
						<AttachButton objectID={props.commentBuffer.commentID} path={props.path} icon={true} style={{position:"absolute", right: "0", top: "10px"}}/>
						<div
							className="attachments"
							style={{
								marginBottom: "5px"
							}}
						>
							<AttachmentsList objectID={props.commentBuffer.commentID} removable={true} icon={true} />
						</div>
						<RaisedButton
							label={(mode == 'edit')?"save":"post"}
							type="Submit"
							backgroundColor="#009688"
							labelColor="#FFF"
							className="submit-btn"
							style={{
								width: "60px"
							  , height: "35px"
							  , display: "block"
							  , float: "right"
							}}
							labelStyle={{
								borderRadius: "6px"
							  , lineHeight: "36px"
							}}
						/>
					</form>
				</div>
			</div>
		)
	}
}

export default connect(select, commentActions)(CommentForm)



// WEBPACK FOOTER //
// ./src/components/Communication/CommentForm.js